module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Herman Wouk\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Herman Wouk (1915–2019) was a Pulitzer Prize–winning author of fiction and nonfiction. His works include "), _c('I', [_vm._v("The Caine Mutiny")]), _vm._v(","), _c('I', [_vm._v(" Marjorie Morningstar")]), _vm._v(","), _c('I', [_vm._v(" The Hope")]), _vm._v(", and"), _c('I', [_vm._v(" The Glory")]), _vm._v(". Several of his books have been adapted into films and miniseries. Wouk’s early career as a radio comedy writer included a stint on the Fred Allen Show. He later became a naval officer after the attack on Pearl Harbor in 1941. The son of Russian Jewish immigrants, Wouk’s novels "), _c('I', [_vm._v("The Winds of War ")]), _vm._v("and "), _c('I', [_vm._v("War and Remembrance ")]), _vm._v("delve into Jewish peoples experiences during World War II. In 1999, he received the Jewish Book Council Lifetime Achievement Award.")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/ROZ2gv/tc-custom/9780316077002.jpg?1732164576924",
      "alt": "This image is the cover for the book City Boy"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("City Boy\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("An \"enormously entertaining\" portrait of \"a Bronx Tom Sawyer\" ("), _c('i', [_vm._v("San Francisco Chronicle")]), _vm._v("), "), _c('i', [_vm._v("City Boy")]), _vm._v(" is a sharp and moving novel of boyhood from Pulitzer Prize winner Herman Wouk. ")]), _c('br'), _c('br'), _vm._v("A hilarious and often touching tale of an urban kid's adventures and misadventures on the street, in school, in the countryside, always in pursuit of Lucille, a heartless redhead personifying all the girls who torment and fascinate pubescent lads of eleven.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Little, Brown and Company\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0